import api from '@/services/api'

export default {
  index () {
    return api().get('movies')
  },
  post (movie) {
    return api().post('movies', movie)
  },
  remove (id) {
    return api().post('remove', id)
  },
  edit (movie) {
    return api().post('edit', movie)
  }
}



// WEBPACK FOOTER //
// ./src/services/movies_service.js